
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import { DateColumnConfig } from "@/components/controls/catalogueGrid/columns/dateColumnConfig";
import { CatalogueColumnConfig } from "@/components/controls/catalogueGrid/columns/catalogueColumnConfig";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
  },
  methods: {
    onRowPrepared(e: any) {
      if (e.rowType == "header") {
        e.rowElement.bgColor = "#E5F0FF";
      }
    },
    changeView(){
      this.$emit("change-view", true);
    },
  },
  computed: {},
  data() {
    return {
      toolbarItems: [
        {
          location: "before",
          widget: "dxButton",
          options: {
            text: "Сверка с остатками на складе",
            stylingMode: "outlined",
            onClick: this.changeView,
          },
        },
      ],
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "WeightSummary",
            showInColumn: "weight",
            column: "weight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },
          {
            name: "VolumeSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "PlanCountSummary",
            showInColumn: "planCount",
            column: "planCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
          {
            name: "FactCountSummary",
            showInColumn: "factCount",
            column: "factCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },

          {
            name: "TotalFactWeightSummary",
            showInColumn: "totalFactWeight",
            column: "totalFactWeight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },

          {
            name: "TotalFactVolumeSummary",
            showInColumn: "totalFactVolume",
            column: "totalFactVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },

          {
            name: "ResidueSummary",
            showInColumn: "residue",
            column: "residue",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
        ],
        groupItems: [
          {
            name: "GroupSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
            showInGroupFooter: "true",
          },
          {
            name: "WeightGroupSummary",
            showInColumn: "weight",
            column: "weight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },
          {
            name: "VolumeGroupSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
            showInGroupFooter: "true",
          },
          {
            name: "TotalFactWeightGroupSummary",
            showInColumn: "totalFactWeight",
            column: "totalFactWeight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "TotalFactVolumeGroupSummary",
            showInColumn: "totalFactVolume",
            column: "totalFactVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "PlanCountGroupSummary",
            showInColumn: "planCount",
            column: "planCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },
          {
            name: "FactCountGroupSummary",
            showInColumn: "factCount",
            column: "factCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },
          {
            name: "ResidueGroupSummary",
            showInColumn: "residue",
            column: "residue",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },
        ],
      },
      editingConfig: new TableEditingConfig({
        allowDeleteAll: false,
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowImport: false,
        allowClearFilter: true,
        allowDeleteMultipleRows: false,
        allowGrouping: true,
        allowColumnReordering: true,
        mode: "row",
        chooseColumns: true,
        allowExportToExcel: true,
        exportedFileName: "Пакеты",
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "number",
          caption: "Номер",
          readOnly: true,
        }),

        new TextColumnConfig({
          dataField: "nomenclature",
          caption: "Номенклатура",
        }),

        new TextColumnConfig({
          dataField: "maxLength",
          caption: "Длина (мм)",
        }),

        new TextColumnConfig({
          dataField: "cutSize",
          caption: "Сечение (мм)",
        }),

        new DateColumnConfig({
          dataField: "formationDate",
          caption: "Дата формирования",
          mode: "datetime",
        }),

        new TextColumnConfig({
          dataField: "levelCut",
          caption: "Ярус/Ряд",
        }),

        new DecimalColumnConfig({
          dataField: "weight",
          caption: "Вес (кг)",
          decimalPoints: 0,
          hideFraction: true,
        }),

        new DecimalColumnConfig({
          dataField: "totalFactWeight",
          caption: "Общий вес загрузки (кг)",
          decimalPoints: 0,
          hideFraction: true,
        }),

        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 0,
        }),

        new DecimalColumnConfig({
          dataField: "totalFactVolume",
          caption: "Общий объем загрузки (м³)",
          decimalPoints: 0,
        }),

        new TextColumnConfig({
          dataField: "storagePlace",
          caption: "Складское место",
        }),

        new CatalogueColumnConfig({
          dataField: "packageVolumeTypeDescription",
          caption: "Тип пакета по объему",
          modelIdField: "packageVolumeTypeId",
          modelDescField: "packageVolumeTypeDescription",
          keyField: "id",
          displayField: "packageVolumeTypeDescription",
          displayDescField: "name",
          catalogueComponentName:
            "catalogues/PackageVolumeTypeCatalogue/PackageVolumeTypeCatalogue",
          descriptionColumnName: "packageVolumeTypeDescription",
          allowEmpty: true,
        }),

        new IntegerColumnConfig({
          dataField: "planCount",
          caption: "План (шт)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "factCount",
          caption: "Загружено (шт)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "residue",
          caption: "Остаток (шт)",
          min: 0,
        }),

        new TextColumnConfig({
          dataField: "containerNumbers",
          caption: "Контейнер",
        }),

        new TextColumnConfig({
          dataField: "orderNumber",
          caption: "Номер заказа",
          readOnly: true,
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: false,
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "multiple",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
